import { render, staticRenderFns } from "./SolicitudesPendientesAprobacion.vue?vue&type=template&id=ad4645d4"
import script from "./SolicitudesPendientesAprobacion.vue?vue&type=script&lang=js"
export * from "./SolicitudesPendientesAprobacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports